var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircle5(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.11111,
    y: 1.11111,
    width: 17.7778,
    height: 17.7778,
    rx: 8.88889,
    fill: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.11111,
    y: 1.11111,
    width: 17.7778,
    height: 17.7778,
    rx: 8.88889,
    stroke: "white",
    strokeWidth: 2.22222
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8423 11.956C10.8423 11.7412 10.7941 11.5523 10.6978 11.3893C10.6015 11.219 10.4349 11.0782 10.1978 10.9671C9.9608 10.856 9.64228 10.7708 9.24228 10.7115C8.84228 10.6523 8.33858 10.6227 7.73117 10.6227C7.81266 9.93377 7.87932 9.23377 7.93117 8.52266C7.98303 7.81155 8.02377 7.14488 8.0534 6.52266H12.2201V7.91155H9.44228C9.42747 8.17821 9.40895 8.43747 9.38673 8.68932C9.37191 8.93377 9.3534 9.14858 9.33117 9.33377C10.4127 9.40784 11.209 9.6634 11.7201 10.1004C12.2386 10.5301 12.4978 11.1301 12.4978 11.9004C12.4978 12.256 12.4349 12.5856 12.309 12.8893C12.183 13.193 11.9941 13.456 11.7423 13.6782C11.4904 13.9004 11.1719 14.0745 10.7867 14.2004C10.409 14.3264 9.96451 14.3893 9.4534 14.3893C9.2534 14.3893 9.04228 14.3745 8.82006 14.3449C8.60525 14.3227 8.39414 14.2893 8.18673 14.2449C7.98673 14.2078 7.80525 14.1671 7.64228 14.1227C7.47932 14.0782 7.3534 14.0338 7.26451 13.9893L7.56451 12.6227C7.74969 12.7041 7.99414 12.7856 8.29784 12.8671C8.60154 12.9412 8.96451 12.9782 9.38673 12.9782C9.89784 12.9782 10.2682 12.8782 10.4978 12.6782C10.7275 12.4708 10.8423 12.2301 10.8423 11.956Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle5);
export default __webpack_public_path__ + "static/media/circle_5.7150901aaed5b21ae92383779f0ecbbb.svg";
export { ForwardRef as ReactComponent };